/* Moment */
import moment from "moment"


/* The way of a lead: new → contacted → demo → won | lost. Every stage keeps one colour */
export const STAGES = [
    { key: "new", text: "Новые", short: "Новый", hint: "Ещё никто не говорил", accent: "blue", icon: "sparkle" },
    { key: "contacted", text: "Связались", short: "Связались", hint: "Был разговор", accent: "violet", icon: "phone" },
    { key: "demo", text: "Демо", short: "Демо", hint: "Показали Bookify Pro, ждём решения", accent: "orange", icon: "eye" },
    { key: "won", text: "Подключены", short: "Подключён", hint: "Оплатил подписку", accent: "green", icon: "check" },
    { key: "lost", text: "Отказ", short: "Отказ", hint: "Не сейчас", accent: "grey", icon: "close" }
]

export const stageOf = key => {
    const stage = STAGES.find(item => item.key === key)
    return stage ? stage : STAGES[0]
}

/* Where a lead comes from. Three of the four are found by the system itself */
export const SOURCES = {
    form: { text: "Заявка с сайта", short: "Сайт", hint: "Оставил номер на bookify.kz/partnership", accent: "green", icon: "notification" },
    pro: { text: "Вошёл в Pro", short: "Pro без точки", hint: "Вошёл в Bookify Pro по коду и не открыл точку", accent: "violet", icon: "master" },
    point: { text: "Точка без оплаты", short: "Без оплаты", hint: "Точка работает, подписка не оплачена", accent: "orange", icon: "organization" },
    manual: { text: "Добавлен вручную", short: "Вручную", hint: "Холодный звонок, знакомые, выставка", accent: "blue", icon: "edit" }
}

export const sourceOf = key => SOURCES[key] ? SOURCES[key] : SOURCES.manual

/* What the business does */
export const NICHES = {
    beauty: "Салон красоты",
    barber: "Барбершоп",
    nails: "Маникюр",
    cosmetology: "Косметология",
    spa: "SPA и массаж",
    carwash: "Автомойка",
    service: "СТО и шиномонтаж",
    other: "Другое"
}

/* Why a lead said no */
export const REASONS = {
    expensive: "Дорого",
    no_time: "Не сейчас",
    has_system: "Уже есть система",
    no_answer: "Не отвечает",
    closed: "Закрылись",
    not_target: "Не наш клиент",
    other: "Другое"
}

/* When to call back — the quick choices */
export const NEXT_CHOICES = [
    { key: "today", text: "Сегодня вечером", date: () => moment().hour(18).minute(0).second(0) },
    { key: "tomorrow", text: "Завтра", date: () => moment().add(1, "day").hour(11).minute(0).second(0) },
    { key: "three", text: "Через 3 дня", date: () => moment().add(3, "days").hour(11).minute(0).second(0) },
    { key: "week", text: "Через неделю", date: () => moment().add(7, "days").hour(11).minute(0).second(0) }
]

/* The next call in words and how pressing it is: late, today or later */
export const nextOf = value => {

    if (!value) {
        return null
    }

    const date = moment(value)
    const days = moment(date).startOf("day").diff(moment().startOf("day"), "days")

    if (days < 0) {
        return { accent: "red", text: days === -1 ? "вчера" : `${-days} дн. назад`, late: true }
    }

    if (days === 0) {
        return { accent: "orange", text: `сегодня ${date.format("HH:mm")}` }
    }

    if (days === 1) {
        return { accent: "blue", text: `завтра ${date.format("HH:mm")}` }
    }

    return { accent: "grey", text: date.format("D MMM, HH:mm") }
}

/* The title of a lead — the business first, the person second */
export const titleOf = lead => {

    const business = lead.business && `${lead.business}`.trim() ? `${lead.business}`.trim() : null
    const name = lead.name && `${lead.name}`.trim() ? `${lead.name}`.trim() : null

    if (business) {
        return { title: business, subtitle: name }
    }

    if (lead.organization) {
        return { title: lead.organization, subtitle: name }
    }

    return { title: name ? name : "Без имени", subtitle: null }
}

/* Minutes as a person says them */
export const minutesText = minutes => {

    if (minutes === null || minutes === undefined) {
        return "—"
    }

    if (minutes < 60) {
        return `${minutes} мин`
    }

    if (minutes < 60 * 24) {
        return `${Math.round(minutes / 60)} ч`
    }

    return `${Math.round(minutes / 60 / 24)} дн`
}
